import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import { UseQueryResult } from '@tanstack/react-query'

import { ActiveFarmPanelProps } from './components/active-farm-panel/ActiveFarmPanel'
import { DepositCTAPanelProps } from './components/deposit-cta-panel/DepositCTAPanel'
import { Timeframe } from '@/ui/charts/defaults'

export interface SpkFarmHistoryItem {
  date: Date
  apy: Percentage
  tvl: NormalizedNumber
}

export type SpkFarmHistoryQueryResult = UseQueryResult<SpkFarmHistoryItem[]>
export const SPK_FARM_HISTORY_TIMEFRAMES = ['7D', '1M', '1Y', 'All'] as const satisfies Timeframe[]
export type SpkFarmHistoryTimeframe = (typeof SPK_FARM_HISTORY_TIMEFRAMES)[number]

export interface SpkFarmChartDetails {
  history: SpkFarmHistoryQueryResult
  onTimeframeChange: (timeframe: Timeframe) => void
  timeframe: SpkFarmHistoryTimeframe
  availableTimeframes: SpkFarmHistoryTimeframe[]
}

export type MainPanelData =
  | {
      type: 'cta'
      props: DepositCTAPanelProps
    }
  | {
      type: 'active'
      props: ActiveFarmPanelProps
    }

export type SpkFarmGeneralStatsResult = UseQueryResult<{
  stakers: number
  tvl: NormalizedNumber
  apr: Percentage
}>
